//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricAnalysis.js";
import "../no/Builder.js";
import "../no/SelectPointList.js";
import "../no/Expression.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[1,"BetweenPoints",0,"SelectPointList",0],[0,"DisplayMethod",1,1],[0,"DisplayMode",1,0],[1,"EndIsoAngle",0,"Expression",0],[1,"Faces",0,"SelectDisplayableObjectList",0],[0,"IsReflectionLocked",1,0],[0,"IsoclineOption",1,0],[0,"IsoclineOrientation",1,0],[0,"IsoclineOrigin",1,0],[0,"IsoclineVector",1,"Direction",0],[0,"LightDiffuseness",1,0],[0,"LightNumber",1,0],[0,"LightPlacement",1,0],[0,"LightPlaneOrigin",0,0],[0,"LightPlaneXAxis",0,0],[0,"LightPlaneYAxis",0,0],[0,"LightSpacing",1,0],[0,"LightWidth",1,0],[0,"Output",1,0],[0,"Resolution",1,0],[1,"StartIsoAngle",0,"Expression",0],[1,"ThroughPoints",0,"SelectPointList",0],[0,"Type",1,1],[0,"Type2",1,0]],[[["nDarkColor"],"GetDarkColor",{R_:{darkColor:""}},0,0],[["darkColor"],"SetDarkColor",{},1,0],[["nBrightColor"],"GetBrightColor",{R_:{brightColor:""}},0,0],[["brightColor"],"SetBrightColor",{},1,0],[[],"ReinitializePlane",{},0,1],[["origin"],"SetLightPlaneOrigin",{},1,0],[["xAxis"],"SetLightPlaneXAxis",{},1,0],[["yAxis"],"SetLightPlaneYAxis",{},1,0]],[]];
SPLM.GeometricAnalysis.HighlightLinesAnalysisBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricAnalysis.HighlightLinesAnalysisBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricAnalysis.HighlightLinesAnalysisBuilder.Types = Object.freeze({
    "Uniform" : "Uniform", "ThroughPoints" : "ThroughPoints", "BetweenPoints" : "BetweenPoints"});

SPLM.GeometricAnalysis.HighlightLinesAnalysisBuilder.Types2 = Object.freeze({
    "Reflection" : "Reflection", "Projection" : "Projection", "Isoclines" : "Isoclines", "Zebra" : "Zebra"});

SPLM.GeometricAnalysis.HighlightLinesAnalysisBuilder.Resolutions = Object.freeze({
    "Coarse" : "Coarse", "Standard" : "Standard", "Fine" : "Fine", "ExtraFine" : "ExtraFine", "SuperFine" : "SuperFine", "UltraFine" : "UltraFine"});

SPLM.GeometricAnalysis.HighlightLinesAnalysisBuilder.DisplayMethods = Object.freeze({
    "Reflection" : "Reflection", "Projection" : "Projection"});

SPLM.GeometricAnalysis.HighlightLinesAnalysisBuilder.LightPlacements = Object.freeze({
    "Uniform" : "Uniform", "ThroughPoints" : "ThroughPoints", "BetweenPoints" : "BetweenPoints"});

SPLM.GeometricAnalysis.HighlightLinesAnalysisBuilder.LightPlaneOptions = Object.freeze({
    "YZ" : "YZ", "ZX" : "ZX", "XY" : "XY", "Arbitrary" : "Arbitrary"});

SPLM.GeometricAnalysis.HighlightLinesAnalysisBuilder.OutputOption = Object.freeze({
    "AnalysisObject" : "AnalysisObject", "HighlightCurves" : "HighlightCurves", "Both" : "Both"});

SPLM.GeometricAnalysis.HighlightLinesAnalysisBuilder.DisplayModes = Object.freeze({
    "Polyline" : "Polyline", "ZebraMap" : "ZebraMap"});

SPLM.GeometricAnalysis.HighlightLinesAnalysisBuilder.IsoclineDirection = Object.freeze({
    "Vector" : "Vector", "Orientation" : "Orientation"});

export default SPLM;